import {Component, OnInit} from '@angular/core';
import {AdminService} from '../../services/admin.service';
import {District} from '../../models/district/district.model';
import {ActivatedRoute, Router} from '@angular/router';
import {NgForm} from '@angular/forms';
import {FeatureDto} from './featureDto';
import {Level, ToastService} from '../../services/toast.service';

@Component({
  selector: 'sidr-admin-feature',
  templateUrl: 'adminFeature.component.html',
})
export class AdminFeatureComponent implements OnInit {
  feature: FeatureDto | null;
  districts: District[] = [];

  constructor(
    private adminService: AdminService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private toasterService: ToastService
  ) {
    this.feature = null;
  }

  onSubmit(form: NgForm) {
  }

  ngOnInit() {
    this.activeRoute.params.subscribe(params => {
      if (params['feature_id'] && params['feature_id'] !== 'new') {
        this.adminService.getFeature(params['feature_id']).subscribe(r => this.feature = r);
      } else {
        this.feature = new FeatureDto();
      }
    });

    // Load districts
    this.adminService.getDistricts().subscribe(
      districts => this.districts = districts,
      error => this.toasterService.AddNotification(Level.ERROR, 'Feature Service', 'Error loading districts')
    );
  }

  // ... rest of the component code
}
